var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('b-tag',{staticClass:"is-rounded",attrs:{"type":_vm.attrType}},[_c('b-icon',{attrs:{"icon":_vm.attrIcon,"size":"mdi-24px"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }